export default __webpack_public_path__ + "static/motobike1-53ef9c6a79b96a64ae270c99ce4cfebf.png";